// RITA-1585/RITA-1602 — Die PRM-Handbücher mit ihren Kapiteln. Das Verzeichnis ist klein und steht sofort bereit (Auswahl,
// Adresse, gemerktes Kapitel); der Text jedes Handbuchs wird erst bei Bedarf geladen (hooks/useHandbuchTexte). Verzeichnis
// und Text entstehen gemeinsam aus der Umwandlung scripts/handbuch/umwandeln.mjs. Die Kapitelschlüssel der
// Vertragserstellung sind seit RITA-1585 fest (Adresse, localStorage).
import verzeichnis from '../inhalt/verzeichnis.json';

export interface Handbuchkapitel {
  /**
   * Schlüssel für Adresse (`?kapitel=…`) und localStorage. Bei der Vertragserstellung fest, sonst aus dem Kapitelnamen
   * erzeugt: Wird dort ein Kapitel umbenannt, fallen alte Links und gemerkte Kapitel auf den Anfang zurück.
   */
  id: string;
  /** Nummer im Handbuch; null bei einer einzelnen Seite ohne Kapitel („Knöpfe und Symbole im PRM“). */
  nummer: number | null;
  titel: string;
}

export interface Handbuch {
  id: string;
  titel: string;
  kapitel: readonly Handbuchkapitel[];
}

export const HANDBUCH_VERTRAGSERSTELLUNG_ID = 'vertragserstellung';

export const HANDBUECHER: readonly Handbuch[] = verzeichnis;

/** Ein Kapitel eines Handbuchs, eindeutig über beide Schlüssel. */
export interface Kapitelwahl {
  handbuchId: string;
  kapitelId: string;
}

/**
 * Seiten, die das Handbuch zeigen. Jede merkt sich ihr Kapitel für sich (Entscheidung Julia 31.10.2026): Der
 * Vorlagen-Editor und die Kachel öffnen beim ersten Mal Kapitel 1 (Julia, 04.11.2026), der Vertrag am Berater Kapitel 5.
 */
export type Handbuchseite = 'vorlagenEditor' | 'vertragBearbeiten' | 'kachel';

export const STARTKAPITEL: Readonly<Record<Handbuchseite, Kapitelwahl>> = {
  vorlagenEditor: { handbuchId: HANDBUCH_VERTRAGSERSTELLUNG_ID, kapitelId: 'vorbereitungen' },
  vertragBearbeiten: { handbuchId: HANDBUCH_VERTRAGSERSTELLUNG_ID, kapitelId: 'vertrag-bearbeiten' },
  kachel: { handbuchId: HANDBUCH_VERTRAGSERSTELLUNG_ID, kapitelId: 'vorbereitungen' },
};

export function handbuchFinden(handbuchId: string, handbuecher: readonly Handbuch[] = HANDBUECHER): Handbuch | null {
  return handbuecher.find((handbuch) => handbuch.id === handbuchId) ?? null;
}

export function kapitelFinden(
  wahl: Kapitelwahl,
  handbuecher: readonly Handbuch[] = HANDBUECHER,
): { handbuch: Handbuch; kapitel: Handbuchkapitel } | null {
  const handbuch = handbuchFinden(wahl.handbuchId, handbuecher);
  const kapitel = handbuch?.kapitel.find((eintrag) => eintrag.id === wahl.kapitelId);
  return handbuch && kapitel ? { handbuch, kapitel } : null;
}

/** Prüft fremde Werte (Adresse, localStorage) und liefert nur eine Wahl, die es wirklich gibt. */
export function gueltigeKapitelwahl(
  handbuchId: unknown,
  kapitelId: unknown,
  handbuecher: readonly Handbuch[] = HANDBUECHER,
): Kapitelwahl | null {
  if (typeof handbuchId !== 'string' || typeof kapitelId !== 'string') return null;
  const wahl = { handbuchId, kapitelId };
  return kapitelFinden(wahl, handbuecher) ? wahl : null;
}

/** Anzeige „3. Vertragsvorlagen bearbeiten und prüfen“ – so steht es in Auswahl, Überschrift und Treffern. */
export function kapitelBezeichnung(kapitel: Handbuchkapitel): string {
  return kapitel.nummer === null ? kapitel.titel : `${kapitel.nummer}. ${kapitel.titel}`;
}
